/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SummaryRequestBuilderRequestsMetadata, type SummaryRequestBuilder } from './summary/index.js';
// @ts-ignore
import { TopByRevenueRequestBuilderRequestsMetadata, type TopByRevenueRequestBuilder } from './topByRevenue/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/products
 */
export interface ProductsRequestBuilder extends BaseRequestBuilder<ProductsRequestBuilder> {
    /**
     * The summary property
     */
    get summary(): SummaryRequestBuilder;
    /**
     * The topByRevenue property
     */
    get topByRevenue(): TopByRevenueRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ProductsRequestBuilderUriTemplate = "{+baseurl}/api/analytics/products";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ProductsRequestBuilderNavigationMetadata: Record<Exclude<keyof ProductsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    summary: {
        requestsMetadata: SummaryRequestBuilderRequestsMetadata,
    },
    topByRevenue: {
        requestsMetadata: TopByRevenueRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
